define('home/views/MessageView',[
    'backbone-marionette',

    'home/templates/message',
], function (
    Marionette,

    messageTemplate
) {
    'use strict';
    var MessageView = Marionette.ItemView.extend({
        template: messageTemplate,
        events: {
            'click [data-action=hide-message]': 'close',
        },

        close: function (evt) {
            evt.preventDefault();
            this.remove();
        },
    });

    return MessageView;
});

